import { BaseCamelCasedResource } from "./BasePlainResource";
import { legacyApiResourceUrl } from "@ploy-lib/core";
class CustomerInfoSearchResource extends BaseCamelCasedResource {
    pk() {
        return this.cust?.customerNumber || this.cust?.customerCompanyNumber;
    }
    static async fetch(input, init) {
        const response = await super.fetch(input, init);
        if (response?.error !== "OK") {
            const error = new Error(response.message);
            error.status = 400;
            throw error;
        }
        return response;
    }
}
CustomerInfoSearchResource.urlTemplates = [
    legacyApiResourceUrl("CustomerSearchJson/SearchCustomerNoWithDynCalcModel?custNo={custNo}"),
    legacyApiResourceUrl("CustomerSearchJson/SearchCompanyNoWithDynCalcModel?orgno={orgno}")
];
CustomerInfoSearchResource.urlRoot = legacyApiResourceUrl("CustomerSearchJson");
export { CustomerInfoSearchResource };
//# sourceMappingURL=CustomerInfoSearchResource.js.map